export type ContactKeys = 'phone' | 'email';
export type AboutKeys = 'clinic' | 'doctor';

export const contactsTabs: { name: string, key: ContactKeys }[] = [
  {
    name: 'Телефон',
    key: 'phone',
  },
  {
    name: 'Email',
    key: 'email',
  },
];
export const aboutTabs: { name: string, key: AboutKeys }[] = [
  {
    name: 'О клинике',
    key: 'clinic',
  },
  {
    name: 'О враче',
    key: 'doctor',
  },
];